<!-- Container-fluid starts-->
<div class="container">
    <div class="row">
        <div class="col-sm-3 info-stat-block">
            <!-- Left panel -->
            <div class="vendu">
                <div class="number">{{this.shop.orderFinished}}</div>
                <div class="number-info">Commande<span *ngIf="this.shop.orderFinished > 1">s</span> terminée<span
                        *ngIf="this.shop.orderFinished > 1">s</span>
                </div>
            </div>
            <div class="refuse">
                <div class="number">{{this.shop.orderProcessing}}</div>
                <div class="number-info">Commande<span *ngIf="this.shop.orderProcessing > 1">s</span> en cours</div>
            </div>
        </div>
        <!-- Right panel -->
        <div class="col-sm-8 offset-1 info-block">
            <div class="nom-id">
                {{this.shop.shopName}}
            </div>
            <div class="info">
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column flex-50 user-image">
                        <div class="logo_account">
                            <img alt="" [src]="url? url:'assets/images/banner/1.jpg'">
                        </div>
                        <!-- isFitting -->
                        <p class="title">Option</p>
                        <div class="info-detail-block d-flex flex-column">
                            <div>
                                <p *ngIf="!this.shop.isFittingShop">Sans possibilité de pose</p>
                                <p *ngIf="this.shop.isFittingShop">Possibilité de pose</p>
                            </div>
                            <div>
                                <p *ngIf="!this.shop.isWeb">Sans possibilité de commandes en ligne</p>
                                <p *ngIf="this.shop.isWeb">Possibilité de commandes en ligne</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-50">
                        <p class="title">Localisation</p>
                        <!-- Address -->
                        <div class="info-detail-block d-flex flex-row">
                            <i class="fa fa-home" aria-hidden="true"></i>
                            <div>
                                <p>{{this.shop.shopAddress}}</p>
                                <p>{{this.shop.shopAddressSup}}</p>
                                <p>{{this.shop.shopPostalCode}} {{this.shop.shopCity}} {{this.shop.shopCountry}}</p>
                            </div>
                        </div>
                        <!-- Geolocation -->
                        <div class="info-detail-block d-flex flex-row" *ngIf="this.shop.geolocation">
                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                            <div>
                                <p>{{this.shop.geolocation}}</p>
                            </div>
                        </div>
                        <div class="produit">
                            <!-- Contact -->
                            <p class="title">Contact</p>
                            <div class="info-detail-block d-flex flex-row" *ngIf="this.shop.email">
                                <i class="fa fa-envelope-o" aria-hidden="true"></i>
                                <div>
                                    <p>{{this.shop.email}}</p>
                                </div>
                            </div>
                            <div class="info-detail-block d-flex flex-row" *ngIf="this.shop.telephoneNumber !== ''">
                                <i class="fa fa-phone" aria-hidden="true"></i>
                                <div>
                                    <p>{{this.shop.telephoneNumber}}</p>
                                </div>
                            </div>
                        </div>
                        <p class="title">Site Marchand</p>
                        <div class="info-detail-block d-flex flex-row" *ngIf="this.shop.subDomainName">
                            <i class="fa fa-globe" aria-hidden="true"></i>
                            <div>
                                <p>{{this.shop.subDomainName}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_container_account">
                <button class="modify modify-info btn_modify_info" (click)="openAccountModification()">
                    Modifier mes informations
                    <span>
                        <i class="fa fa-edit fa-lg" aria-hidden="true"></i>
                    </span>
                </button>
                <button class="modify modify-pass btn_modify_pwd" (click)="openAccountModificationPassword()">
                    Modifier mon mot de passe
                    <span>
                        <i class="fa fa-lock fa-lg" aria-hidden="true"></i>
                    </span>
                </button>
                <button class="delete delete-pass btn_delete" (click)="openDeleteAccount()">
                    Supprimer mon compte
                    <span>
                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                    </span>
                </button>
                <span class="warning-text mt-3 mb-3">
                    *Attention, la suppression de votre compte entraîne la suppression de l’ensemble des données relatives au groupe Corso et à l’utilisation de son application Phi : Assistant menuisier
                </span>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->